export const  getOrdinal = (n: number): string => {
    const suffixes = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
  }

export function isVetSource(): boolean {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('source') === 'VET';
}